import Dashboard from "../common/dashboard"
import PieChart from "../common/pieChart"

import "./riskScore.css"

import RiskScoreList from './riskScoreList'
import { useAppSelector } from "@/app/hooks"
import { selectAnalysisData, selectLoadScorigingAnalysis } from "./addressSlice"



export default function RiskScore(props: { depth?: number, showAssets: boolean, symbol: string, onChangeType: Function, onChangeSelect?: Function, onChangeDepth?: Function }) {
  const analysisData = useAppSelector(selectAnalysisData);
  const loadAnalysisData = useAppSelector(selectLoadScorigingAnalysis);

  return (
    <div className="riskscore-container">
      <div className="left">
        <RiskScoreList depth={props.depth} symbol={props.symbol} showAssets={props.showAssets} onChangeType={props.onChangeType} onChangeSelect={props.onChangeSelect} onChangeDepth={props.onChangeDepth} />
      </div>
      <div className="right">
        <Dashboard score={analysisData ? analysisData.score : 0} loading={loadAnalysisData} />

        <div className="pie-lmt"></div>

        <PieChart data={analysisData ? analysisData.details : []} loading={loadAnalysisData} icon="https://static.scorechain.com/public-storage/blockchain/bitcoin.svg" />
      </div>
    </div>
  )
}